import type { Services } from '../../store/slices/timesheet/timesheetPageSlice';
import type {
  KmsVehicle,
  ServiceExecutionUpdateRequest,
} from '../../store/slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsSlice';

export function mapServicesForApproval(
  pageServices: Services[],
): ServiceExecutionUpdateRequest[] {
  const finalCopy: ServiceExecutionUpdateRequest[] = [];
  for (let i = 0; i < pageServices.length; i++) {
    const serviceInstance = pageServices[i];
    const { service, serviceExecution } = serviceInstance;
    finalCopy[i] = {
      serviceId: service.serviceId,
      pax: serviceExecution?.pax ?? service.pax,
      isClean: serviceExecution?.isClean ?? service.isClean,
      startDateTime: serviceExecution?.startDateTime ?? service.startDateTime,
      endDateTime: serviceExecution?.endDateTime ?? service.endDateTime,
      isAU: service?.isAU ?? false,
      kmsVehicles: serviceExecution?.kmsVehicles?.map((kv) => ({
        kmsId: kv.kmsId,
        kmsIni: kv.kmsIni,
        kmsEnd: kv.kmsEnd,
        inEmpty: kv.inEmpty,
      })) as KmsVehicle[],
    };
  }
  return [...finalCopy];
}

export function mapServicesForEdit(
  acceptedServices: ServiceExecutionUpdateRequest[],
): ServiceExecutionUpdateRequest[] {
  const finalCopy: ServiceExecutionUpdateRequest[] = [];
  for (let i = 0; i < acceptedServices?.length; i++) {
    const service = acceptedServices[i];
    finalCopy[i] = { ...service };
  }
  return [...finalCopy];
}
